/**
 * Color theme switcher
 */

const color_theme_switcher = (args) => {
    // setup args
    let selectors = args.selectors;
    let toggles = args.toggles;

    // validate
    if (!selectors.length && !toggles.length) {
        return;
    }

    // Load the last selected color theme from local storage
    const initialColorTheme = localStorage.getItem('colorTheme');

    if (!initialColorTheme) {
        console.error('Color theme not found in local storage!');
        return;
    }

    const toggle_themes = ['light', 'dark']; // Must have two elements
    const select_themes = ['light', 'dark', 'os-default'];

    function clear_document_class(themes) {
        themes.forEach((theme) => {
            document.documentElement.classList.remove('-theme-' + theme);
        });
    }

    function update_toggle_modifier(toggle, theme) {
        if (theme === toggle_themes[0]) {
            toggle.classList.add('-' + toggle_themes[0]);
            toggle.classList.remove('-' + toggle_themes[1]);
        } else {
            toggle.classList.add('-' + toggle_themes[1]);
            toggle.classList.remove('-' + toggle_themes[0]);
        }
    }

    function init() {
        selectors.forEach((selector) => {
            selector.value = initialColorTheme;
        });

        toggles.forEach((toggle) => {
            update_toggle_modifier(toggle, initialColorTheme);
        });

        // Listen for changes to the color theme select element and update the page accordingly
        selectors.forEach((selector) => {
            selector.addEventListener('change', function () {
                const selectedTheme = this.value;

                // Set document class
                clear_document_class(select_themes);
                document.documentElement.classList.add(
                    `-theme-${selectedTheme}`
                );

                // Update local storage
                localStorage.setItem('colorTheme', selectedTheme);
            });
        });

        // Listen for changes to the color theme select element and update the page accordingly
        toggles.forEach((toggle) => {
            toggle.addEventListener('click', function () {
                // prettier-ignore
                const selectedTheme = this.classList.contains('-' + toggle_themes[0]) ? toggle_themes[1] : toggle_themes[0];

                // Set document class
                clear_document_class(select_themes);
                document.documentElement.classList.add(
                    `-theme-${selectedTheme}`
                );

                // Set toggle modifier class
                update_toggle_modifier(this, selectedTheme);

                // Update local storage
                localStorage.setItem('colorTheme', selectedTheme);
            });
        });
    }

    init();

    // make the call chainable
    return this;
};

color_theme_switcher({
    selectors: document.querySelectorAll('.js-theme-selector'),
    toggles: document.querySelectorAll('.js-theme-toggle'),
});
